let headerMenu = document.getElementById('headerMenu');
let headerNavigationLayer = document.getElementById('headerNavigationLayer');
let headerNavigationLayerLvl02 = document.getElementsByClassName('header_navigation_layer_lvl_02');

// Header menu toggle
function headerMenuToggle() {
  const isMobile = window.matchMedia('(max-width: 1199px)');

  if (isMobile.matches) {
    // noScroll class
    if (headerSearch.classList.contains('is-active')) {
      document.body.classList.add('noScroll');
    } else {
      document.body.classList.toggle('noScroll');
    }

    // Close header search
    headerSearch.classList.remove('is-active');
    headerSearchFormWrapperDesktop.classList.remove('is-active');
    headerSearchLayer.classList.remove('is-active');

    // Toggle header menu
    headerMenu.classList.toggle('is-active');
    headerNavigationLayer.classList.toggle('is-active');
  }
}

// Header menu close
function headerMenuClose() {
  headerMenu.classList.remove('is-active');
  headerNavigationLayer.classList.remove('is-active');
  document.body.classList.remove('noScroll');

  for (let i = 0; i < headerNavigationLayerLvl02.length; i++) {
    headerNavigationLayerLvl02[i].classList.remove('is-active');
  }
}

headerMenu.addEventListener('click', headerMenuToggle);
let headerNavigationLayerCloser = document.querySelectorAll('.header_navigation_layer_closer');
if (headerNavigationLayerCloser.length) {
  headerNavigationLayerCloser.forEach(function(element){
    element.addEventListener('click', headerMenuClose);
  });
}
